import { LegalLayout } from "@/components/LegalLayout";
import { Scale } from "lucide-react";

const sections = [
  { heading: "Our role under the DSA", body: (
    <p>As a hosting and online-marketplace service, we act as an intermediary between independent sellers and buyers. We do not manufacture or own the products listed by third-party sellers, but we take active steps to keep the platform safe, transparent and trustworthy.</p>
  ) },
  { heading: "Notice & action mechanism", body: (
    <p>Anyone can notify us of illegal content, unsafe products or policy violations through our <a className="text-primary underline underline-offset-2" href="/disputes">Disputes & Reports</a> portal or, for intellectual-property matters, via <a className="text-primary underline underline-offset-2" href="/report-ip-violation">Report an IP Violation</a>. We assess every valid notice promptly and act in a diligent, non-arbitrary manner.</p>
  ) },
  { heading: "Trader traceability (KYC)", body: (
    <p>In line with Article 30 DSA, sellers must provide and verify identification and business details before listing products. Documents are reviewed by our compliance team prior to approval.</p>
  ) },
  { heading: "Statement of reasons & appeals", body: (
    <p>Where we remove content or restrict an account, we provide the affected user with a clear statement of reasons and the opportunity to appeal through our internal complaint-handling system.</p>
  ) },
  { heading: "UK Online Safety Act", body: (
    <p>For users in the United Kingdom, we apply proportionate measures to protect users from illegal and harmful content, including reporting tools, content moderation and age-appropriate safeguards.</p>
  ) },
  { heading: "Nigeria compliance", body: (
    <p>For our operations in Nigeria, we align with the Federal Competition and Consumer Protection Act (FCCPA) enforced by the <strong>FCCPC</strong> for fair trading and consumer protection, and with the Nigeria Data Protection Act (NDPA) overseen by the <strong>NDPC</strong> for personal-data handling. Sellers on our platform must comply with applicable Nigerian product-safety, labelling and licensing rules.</p>
  ) },
  { heading: "Single point of contact", body: (
    <p>Authorities and users can reach our compliance function via the <a className="text-primary underline underline-offset-2" href="/contact">Contact</a> page. Our EU, UK and Nigeria points of contact operate in English.</p>
  ) },
  { heading: "Transparency", body: (
    <p>We publish periodic transparency information about moderation and enforcement in our <a className="text-primary underline underline-offset-2" href="/transparency">Transparency Center</a>.</p>
  ) },
];

export default function DSAInformation() {
  return (
    <LegalLayout
      title="DSA / OSA Information"
      icon={Scale}
      testid="dsa-osa-page"
      intro="Xurray Mart operates as an online marketplace serving the EU and Nigeria, and is committed to compliance with the EU Digital Services Act (DSA), the UK Online Safety Act (OSA), and Nigeria's FCCPA and NDPA. This page sets out our obligations and how you can exercise your rights."
      sections={sections}
    />
  );
}
